import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './CreateGroupModal.css';

const DeleteGroupModal = ({ show, handleClose, groupName, handleDelete, deleteType }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '18px' }}>
        {deleteType === 'customSearch' ? 'Disclaimer' : 'Confirm'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {deleteType === 'customSearch'
            ? <>Are you sure you want to delete this search??</>
            : <>Are you sure you want to delete the <strong>{groupName}</strong> group prototype?</>}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleDelete} className="create-button">
          Delete
        </Button>
        <Button variant="secondary" onClick={handleClose} className="cancell-button cancell-button-container">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteGroupModal;
